import React from 'react';
import { FooterBrand } from './footer/FooterBrand';
import { ContactColumn, OfficeColumn, GuidesColumn, QuickLinksColumn } from './footer/FooterColumns';
import { FooterBadges, FooterLegal } from './footer/FooterLegal';

export const Footer = ({ navItems, openPrivacyPolicy }) => (
  <footer className="bg-gradient-to-b from-[#143160] to-[#0B1F3F]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12">
      <FooterBrand />
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 border-t border-white/10 pt-10">
        <ContactColumn />
        <OfficeColumn />
        <GuidesColumn />
        <QuickLinksColumn navItems={navItems} />
      </div>
    </div>
    <FooterBadges />
    <FooterLegal openPrivacyPolicy={openPrivacyPolicy} />
  </footer>
);
